import { put, call, takeLatest } from "redux-saga/effects";
import { actions } from "./Reducer";
import * as api from './Api';

import {
  getFavSupplierProductsSuccessAction,
  removeFavSupplierProductSuccessAction,
  setCustomerFavSupplierProductsCountAction,
  setCustomerFavSupplierProductsIsLoadingAction,
  setSearchValueAction
} from './Actions';
import {
  newErrorNotificationAction,
  newSuccessNotificationAction,
  errorNotificationFromError,
} from "../notifications/Actions";


function* getFavSupplierProductsSaga ({payload }) {
  const id = payload
  try {
    yield put(setCustomerFavSupplierProductsIsLoadingAction(true))
    const response = yield call(api.getFavSupplierProducts,id)
    const {data} = response;

    yield put (getFavSupplierProductsSuccessAction(data.favSProducts))
  } catch (error) {
   yield put(errorNotificationFromError(error))
  } finally {
    yield put(setCustomerFavSupplierProductsIsLoadingAction(false))
  }
}

function* removeFavSupplierProductSaga ({payload: {customerId, productID}}) {
  const ids = {
    customerId,
    productID
  }
  try {
    yield put(setCustomerFavSupplierProductsIsLoadingAction(true))
    yield call(api.remFavSupplierProduct,ids);
    console.log(customerId)
    yield put(removeFavSupplierProductSuccessAction(productID))
    yield put(newSuccessNotificationAction('Product has been Removed'))
  } catch(error) {
   yield put(errorNotificationFromError(error))
  } finally {
    yield put(setCustomerFavSupplierProductsIsLoadingAction(false))
  }
}


export default function*() {
  // yield takeLatest(actions.DELETE_CUSTOMER, deleteCustomer);
  yield takeLatest(actions.GET_FAV_SUPPLIER_PRODUCTS, getFavSupplierProductsSaga)
  yield takeLatest(actions.REM_FAV_SUPPLIER_PRODUCTS,removeFavSupplierProductSaga )
}